import { call, put, select, takeEvery } from 'typed-redux-saga'
import { ResponseCatalog, RequestParams, ShortDataModel } from 'Models'
import { unionBy } from 'lodash'
import { errorHandler } from 'Modules'
import {
	FILL_FIELDS,
	selectApi,
	SelectNS,
	selectSelectors,
	selectSlice,
	prepareDictData,
} from 'Modules/Select'

function* getAllByKey(action: SelectNS.GetAllByKey) {
	try {
		const { params, options, key, callback } = action.payload
		let paramsForRequest: RequestParams
		if (params) {
			paramsForRequest = params
		} else {
			const paramsAll = yield* select(selectSelectors.getRequestParams)
			paramsForRequest = paramsAll?.[key] ?? new RequestParams()
		}
		let res
		if (
			FILL_FIELDS[key] &&
			params?.query &&
			(params.query.includes(',') || params.query.includes(';'))
		) {
			const arr = params.query.includes(',') ? params.query?.split(',') : params.query?.split(';')
			for (let i = 0; i < arr.length; i += 1) {
				const item = arr[i].trim()
				res = yield* call(
					selectApi.getAllByKey,
					{
						...paramsForRequest,
						query: item,
					} as RequestParams,
					key
				)
				yield* put(
					selectSlice.actions.setAllByKey({ data: new ResponseCatalog<ShortDataModel>(res), key })
				)
				res.entries.forEach((element: ShortDataModel) => {
					if (element?.[FILL_FIELDS[key]] === item) {
						callback?.([element.id], true)
					}
				})
			}
		} else {
			res = yield* call(selectApi.getAllByKey, paramsForRequest, key)
			const resData = new ResponseCatalog<ShortDataModel>(res)
			if (options?.loadMore || options?.searchMissing) {
				const oldAll = yield* select(selectSelectors.getAll)
				const oldData = oldAll?.[key] ?? new ResponseCatalog<ShortDataModel>()
				resData.entries = options?.searchMissing
					? oldData.entries.concat(resData.entries)
					: unionBy(oldData.entries, resData.entries, 'id')
				if (options?.searchMissing) resData.total_entries = oldData.total_entries
			}
			yield* put(selectSlice.actions.setAllByKey({ data: resData, key }))
			const all = yield* select(selectSelectors.getAll)
			callback?.(all?.[key])
		}
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* getDictByKey(action: SelectNS.GetDictByKey) {
	try {
		const { key, callback } = action.payload
		const res = yield* call(selectApi.getDictByKey, key)
		yield* put(selectSlice.actions.setAllByKey({ data: prepareDictData(res, key), key }))
		callback?.()
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export function* selectSaga() {
	yield* takeEvery(selectSlice.actions.getAllByKey.type, getAllByKey)
	yield* takeEvery(selectSlice.actions.getDictByKey.type, getDictByKey)
}
